import { useMemo, type ReactNode } from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from 'theme/theme';
import { selectColors } from 'store/entities/dashboard/selectors';
import { useSelector } from 'react-redux';

export const ThemeMuiProvider = ({ children }: { children: ReactNode }) => {
  const colors = useSelector(selectColors());

  const muiTheme = useMemo(
    () =>
      theme({
        primary: colors?.primary,
        secondary: colors?.primaryDark,
        background: colors?.bg_primary,
        paper: colors?.bg_secondary,
      }),
    [colors?.bg_primary, colors?.bg_secondary, colors?.primary, colors?.primaryDark]
  );

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};
